import { render, staticRenderFns } from "./MessengerServiceDetail.vue?vue&type=template&id=1e82aadb&"
import script from "./MessengerServiceDetail.vue?vue&type=script&lang=js&"
export * from "./MessengerServiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./MessengerServiceDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports